<template>
	<v-card class="my_settings_page pt-5 page" flat>
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<div v-else-if="isBlocked !== null">
			<v-skeleton-loader v-if="settingsLoading" v-bind="attrs" type="card" />
			<v-card-text
				v-else-if="settings"
				v-for="(setting, index) in settings.accountSettings"
				:key="index"
			>
				<div
					class="my_settings_page__buttons-block"
					v-if="setting.block_name === 'accountSettings'"
				>
					<div v-for="(item, index) in setting.block_data" :key="index">
						<div
							@click="handleBlockLinkClick(item.uri, item.label)"
							class="my_settings_page__buttons-block__button u-cursor-pointer"
						>
							{{ item.label }}
						</div>
					</div>
				</div>
			</v-card-text>
		</div>
		<v-dialog
			class="my_settings_page__modal"
			v-model="isModal"
			persistent
			:width="typeModal === 'delete-account' ? '500px' : '450px'"
			@click:outside="closeModal"
			@input="onDialogToggle"
		>
			<v-card>
				<div class="my_settings_page__modal__wrapper">
					<div class="d-flex flex-column" v-if="typeModal === 'delete-account'">
						<span class="my_settings_page__modal__wrapper__title text-center"
							>Are you sure you want to delete your account?</span
						>
					</div>
					<div class="d-flex flex-column mb-4" v-else>
						<span class="my_settings_page__modal__wrapper__title mb-5"
							>Change Password</span
						>
						<div class="my_settings_page__modal__field">
							<input
								v-model="password"
								type="password"
								placeholder="New Password"
								class="my_settings_page__modal__input"
							/>
						</div>

						<div class="my_settings_page__modal__field mt-4">
							<input
								v-model="confirmPassword"
								type="password"
								placeholder="Confirm New Password"
								class="my_settings_page__modal__input"
							/>
						</div>
					</div>

					<div class="my_settings_page__modal__wrapper__buttons">
						<button
							class="my_settings_page__modal__wrapper__buttons__button-cancel"
							type="button"
							@click="closeModal"
						>
							Cancel
						</button>
						<button
							class="my_settings_page__modal__wrapper__buttons__button-submit"
							type="button"
							:disabled="isLoading"
							@click="validateAndSubmit"
						>
							<v-progress-circular
								v-if="isLoading"
								indeterminate
								size="20"
								width="2"
								color="white"
							></v-progress-circular>
							<span v-else>
								{{ typeModal === 'delete-account' ? 'Delete' : 'Change' }}</span
							>
						</button>
					</div>
				</div>
			</v-card>
		</v-dialog>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PageBlocked from '@/components/PageBlocked.vue'
import Block from '@/mixins/Block.js'
import Dwh from '@/mixins/Dwh'

export default {
	name: 'AccountSetting',
	components: { PageBlocked },
	mixins: [Block, Dwh],
	data() {
		return {
			attrs: {
				elevation: 0,
			},
			currentId: null,
			isModal: false,
			pageBlockedName: 'profile',
			password: '',
			confirmPassword: '',
			typeModal: '',
		}
	},
	methods: {
		...mapActions('app', ['setPageTitle']),
		...mapActions('auth', ['getSettings', 'changePassword', 'showAlert', 'deleteAccount']),
		dwhViewAccountSettings() {
			this.sendTrigger({
				module: 'My Account',
				category: 'Account Settings',
				action: 'view_account_settings',
				title: 'Account Settings',
				id1: this.currentUser.user_id,
			})
		},
		dwhActionChangePassword() {
			let type = this.changePasswordError ? 'error' : 'success'
			this.sendTrigger({
				module: 'My Account',
				category: 'Account Settings',
				action: 'action_change_password',
				title: 'Change Password',
				id1: this.currentUser.user_id,
				data: type,
			})
		},
		dwhClick(action, title) {
			this.sendTrigger({
				module: 'My Account',
				category: 'Account Settings',
				action: action,
				title: title,
				id1: this.currentUser.user_id,
			})
		},
		onDialogToggle(val) {
			if (!val) {
				setTimeout(() => {
					this.resetModalState()
				}, 200)
			}
		},
		resetModalState() {
			this.password = ''
			this.confirmPassword = ''
			this.typeModal = ''
			this.currentId = null
		},
		closeModal() {
			this.isModal = false
		},
		async validateAndSubmit() {
			if (this.typeModal === 'delete-account') {
				const id = this.currentId
				const success = await this.deleteAccount(id)
				this.dwhClick('action_delete_account', 'Delete Account')
				if (success) {
					this.closeModal()
				}
				return
			} else {
				if (!this.password) {
					return this.showAlert({ message: 'Enter password', type: 'error' })
				}
				if (!this.confirmPassword) {
					return this.showAlert({ message: 'Please confirm password', type: 'error' })
				}
				if (this.password.length < 6) {
					return this.showAlert({ message: 'Min 6 characters', type: 'error' })
				}
				if (this.password !== this.confirmPassword) {
					return this.showAlert({ message: 'Passwords do not match', type: 'error' })
				}
				await this.changePassword({
					id: this.currentId,
					user_password: this.password,
				})
				this.dwhActionChangePassword()
			}
			this.closeModal()
		},
		handleBlockLinkClick(uri, label) {
			if (!uri) return
			if (uri.startsWith('http')) {
				if (label === 'Terms of Use') {
					this.dwhClick('click_terms_of_use', 'Terms of Use')
				}
				if (label === 'Privacy Policy') {
					this.dwhClick('click_privacy_policy', 'Privacy Policy')
				}
				window.open(uri, '_self')
				return
			}
			if (uri.startsWith('com.pinxterapp')) {
				this.typeModal = ''
				const [, pathWithQuery] = uri.split('://')
				const [path, queryString] = pathWithQuery.split('?')
				if (['change-password', 'delete-account'].includes(path)) {
					this.typeModal = path
					const params = new URLSearchParams(queryString)
					this.currentId = params.get('id')
					if (path === 'change-password') {
						this.dwhClick('click_change_password', 'Change password')
					} else {
						this.dwhClick('click_delete_account', 'Delete Account')
					}
					this.isModal = true
					return
				}

				this.$router.push({ path: `/${path}` })
			}
		},
	},
	computed: {
		...mapGetters('auth', [
			'settings',
			'settingsError',
			'settingsLoading',
			'isLoading',
			'profile',
			'changePasswordError',
		]),
		currentUser() {
			return this.profile
		},
	},
	mounted() {
		this.dwhViewAccountSettings()
		this.setPageTitle('Account Settings')
	},
	beforeDestroy() {
		this.setPageTitle('')
	},
	created() {
		this.getSettings()
	},
}
</script>

<style lang="scss">
.my_settings_page {
	background-color: transparent !important;

	&__modal {
		&__field {
			width: 100%;
		}

		&__input {
			width: 100%;
			border: none;
			border-bottom: 1px solid #e2e2e2;
			padding: 10px 0;
			font-size: 16px;
			font-family: 'Inter', sans-serif;
			color: #4a4a4a;
			background: transparent;
			outline: none;
			transition: border-color 0.2s ease;

			&::placeholder {
				opacity: 1;
				font-family: 'Inter', sans-serif;
				font-weight: 400;
				font-size: 18px;
				line-height: 100%;
				letter-spacing: 0;
				color: #9b9b9b;
			}
		}
		&__wrapper {
			padding: 24px;
			display: flex;
			flex-direction: column;
			gap: 16px;
			&__title {
				font-family: 'Inter', sans-serif;
				font-weight: 700;
				font-size: 24px;
				line-height: 100%;
				letter-spacing: 0;
				color: #4a4a4a;
			}
			&__buttons {
				display: flex;
				justify-content: center;
				align-items: center;
				gap: 16px;
				&__button-cancel {
					display: flex;
					justify-content: center;
					align-items: center;
					width: 150px;
					height: 46px;
					border: 1.5px solid var(--button-secondary-background-color);
					border-radius: 8px;
					font-family: 'Inter', sans-serif;
					font-weight: 700;
					font-size: 18px;
					line-height: 100%;
					letter-spacing: 0;
					text-align: center;
					color: var(--button-secondary-background-color);
				}
				&__button-submit {
					display: flex;
					justify-content: center;
					align-items: center;
					width: 150px;
					height: 46px;
					border-radius: 8px;
					background-color: var(--button-main-background-color);
					color: #ffffff;
					font-family: 'Inter', sans-serif;
					font-weight: 700;
					font-size: 18px;
					line-height: 100%;
					letter-spacing: 0;
					text-align: center;
				}
			}
		}
	}

	&__buttons-block {
		display: flex;
		flex-direction: column;
		gap: 8px;
		&__button {
			width: 100%;
			height: 48px;
			border: 1px solid #e2e2e2;
			border-radius: 8px;
			padding: 12px;
			font-family: 'Inter', sans-serif;
			font-weight: 500;
			font-size: 16px;
			letter-spacing: 0;
			background-color: #ffffff;
			color: #4a4a4a;
		}
	}
}
</style>
